import { render, staticRenderFns } from "./formButtons.vue?vue&type=template&id=56eb9582"
import script from "./formButtons.vue?vue&type=script&lang=js"
export * from "./formButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports